export const BRAND = 'Epic Home Pros';
export const PHONE_DISPLAY = '(844) 800-EPIC';
export const PHONE_TEL = '+18448003742';
export const EMAIL = 'hello@epichomepros.com';
export const SITE_URL = 'https://epichomepros.com';
export const HOURS = '8am-9pm · 7 days a week';
